import * as Yup from 'yup';
import { checkBoxRequried, nameRequired, numberRequired } from '.';

export const addPipelineSchema = Yup.object({
    name: nameRequired,
    deal_default_value: numberRequired,
    is_default: checkBoxRequried
});

export const duplicatePipelineSchema = Yup.object({
    id: numberRequired,
    pipeline_name: nameRequired
});